export function sortTable(arrayOfObject, sortingObjectKey, sortingFlag) {
  arrayOfObject = [...arrayOfObject].sort((a, b) => {
    if (sortingFlag) {
      return a[sortingObjectKey] < b[sortingObjectKey]
        ? -1
        : a[sortingObjectKey] > b[sortingObjectKey]
        ? 1
        : 0;
    } else {
      return a[sortingObjectKey] > b[sortingObjectKey]
        ? -1
        : a[sortingObjectKey] < b[sortingObjectKey]
        ? 1
        : 0;
    }
  });

  return arrayOfObject;
}
